import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import { Accordion } from "../../../../accordion/Accordion";
import { AccordionCard } from "../../../../accordion/AccordionCard";
import { UploadingProgress } from "../../UploadingProgress/UploadingProgress";
import { useSortedFileNames } from "../helpers/useSortedFileNames";
import { MultipleFilesUploadStatusBar } from "./MultipleFilesUploadStatusBar";
import styles from "./MultipleFilesUploadAccordion.module.css";
export var MultipleFilesUploadAccordion = function (_ref) {
  var id = _ref.id,
    uploadedFiles = _ref.uploadedFiles,
    _ref$uploadState = _ref.uploadState,
    uploadState = void 0 === _ref$uploadState ? {} : _ref$uploadState,
    uploadErrors = _ref.uploadErrors,
    filesErrors = _ref.filesErrors,
    _ref$total = _ref.total,
    total = void 0 === _ref$total ? {} : _ref$total,
    _ref$completed = _ref.completed,
    completed = void 0 === _ref$completed ? {} : _ref$completed,
    messageProps = _ref.messageProps,
    onActionClick = _ref.onActionClick,
    disableFileRemoveButton = _ref.disableFileRemoveButton,
    sortedFileNames = useSortedFileNames(uploadedFiles, uploadState, filesErrors);
  return uploadedFiles.length > 0 ? React.createElement(Accordion, {
    id: "".concat(id, "_accordion"),
    accordionStates: ["".concat(id, "_accordionCard")],
    className: styles.statusBarAccordion
  }, React.createElement(AccordionCard, {
    id: "".concat(id, "_accordionCard"),
    renderHeader: function (isOpen) {
      return React.createElement(MultipleFilesUploadStatusBar, {
        isOpen: isOpen,
        uploadedFilesNumber: uploadedFiles.length,
        uploadState: uploadState,
        uploadErrors: _objectSpread(_objectSpread({}, uploadErrors), filesErrors)
      });
    },
    className: styles.statusBarAccordionCard,
    cardBodyClassName: styles.statusBarAccordionCardBody
  }, React.createElement("div", {
    role: "list",
    className: styles.container
  }, _mapInstanceProperty(sortedFileNames).call(sortedFileNames, function (name) {
    var _context, _context2;
    return React.createElement(UploadingProgress, {
      variant: "multiple",
      id: _concatInstanceProperty(_context = "".concat(id)).call(_context, name),
      filename: name,
      messageProps: messageProps,
      state: uploadState[name],
      completed: completed[name],
      total: total[name],
      onActionClick: onActionClick(name),
      errorMessages: _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray((null == uploadErrors ? void 0 : uploadErrors[name]) || []), _toConsumableArray(filesErrors[name] || [])),
      key: name,
      role: "listitem",
      disableFileRemoveButton: disableFileRemoveButton
    });
  })))) : null;
};
MultipleFilesUploadAccordion.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "MultipleFilesUploadAccordion",
  props: {
    uploadState: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    },
    total: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    },
    completed: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
}, MultipleFilesUploadAccordion.__docgenInfo = {
  componentName: "MultipleFilesUploadAccordion",
  packageName: "@jutro/components",
  description: "",
  displayName: "MultipleFilesUploadAccordion",
  methods: [],
  actualName: "MultipleFilesUploadAccordion",
  props: {
    uploadState: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    },
    total: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    },
    completed: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
};